import { Link } from "react-router-dom";
import { Gem } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { resolveImg } from "@/lib/api";

export function Logo({ to = "/", testId = "brand-logo" }) {
  const { settings } = useSettings();
  const logo = resolveImg(settings?.logo_url);

  if (logo) {
    return (
      <Link to={to} data-testid={testId} className="flex items-center">
        <img src={logo} alt="RareCandy.sk" className="h-9 w-auto max-w-[180px] object-contain" />
      </Link>
    );
  }

  return (
    <Link to={to} data-testid={testId} className="group flex items-center gap-2.5">
      <span className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-violet-glow to-cyan-glow shadow-[0_0_20px_rgba(139,92,246,0.4)]">
        <Gem className="h-5 w-5 text-white" strokeWidth={2.2} />
      </span>
      <span className="font-display text-lg font-extrabold tracking-tight text-white">
        Rare<span className="holo-text">Candy</span>
        <span className="text-cyan-300">.sk</span>
      </span>
    </Link>
  );
}

export default Logo;
